import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { AppBar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { closeSchedulerModal } from 'Context/NewAgentSchedulerContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const styles = theme => ({
  root: {
    display: 'flex',
    padding: 0,
    backgroundColor: theme.palette.facet.primaryBlueMuted,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  closeButton: {
    color: theme.palette.common.white,
    fontSize: 34,
  },
  titleText: {
    color: theme.palette.common.white,
    fontSize: 32,
  },
});

const SchedulerModalHeader = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  if (householdResource === null) {
    return null;
  }

  const schedulerTitle = `${householdResource?.attr('primaryClientFirstName')} ${householdResource.attr('primaryClientLastName')}`;
  return (
    <AppBar className={classNames(className, classes.root)} elevation={0}>
      <IconButton onClick={closeSchedulerModal}>
        <CloseIcon className={classes.closeButton} />
      </IconButton>
      <div className={classes.titleText}>
        {schedulerTitle}
      </div>
    </AppBar>
  );
};

SchedulerModalHeader.defaultProps = {
  className: '',
};

SchedulerModalHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SchedulerModalHeader);
